<h1 mat-dialog-title [innerText]="data.title"></h1>
<div mat-dialog-content [innerHTML]="data.content">
</div>
<div mat-dialog-actions>
  <button class="cancel-btn" mat-button mat-dialog-close>Cancel</button>
  <button class="remove-btn" mat-raised-button color="accent" [mat-dialog-close]="data.action" cdkFocusInitial>
    <span [innerHTML]="data.action"></span>
  </button>
</div>